import * as R from 'ramda';

import generateId from '../../utils/generateId';

const clearOverrideFilters = store => async state => {
    const userClientId = state.user.selectedUserClientId;
    store.setState(
        R.evolve(
            {
                clients: {
                    [userClientId]: {
                        filters: {
                            overridesId: R.always(generateId()),
                        },
                        media: {
                            filtersOverride: R.always(null),
                        },
                        broadcasts: {
                            filtersOverride: R.always(null),
                        },
                    },
                },
            },
            state,
        ),
    );
};

export default clearOverrideFilters;
